module.exports = __webpack_public_path__ + "img/icon_lxqd.3fa3af16.png";